import React, { PureComponent } from 'react';
import translations from './translations.en.json';
import '@fiverr/globals';
import './index.scss';
import CollapsableLists from './components/CollapsableLists';
import Currency from './components/Currency';
import Social from './components/Social';
import Legal from './components/Legal';

class Footer extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);
    }

    render() {
        const { categories, supportedCurrencies, selectedCurrency } = this.props;

        return (
            <footer className="site-footer">
                <Legal/>
                <CollapsableLists categories={categories}/>
                <div className="currency-social">
                    <Social/>
                    <Currency supportedCurrencies={supportedCurrencies} selected={selectedCurrency}/>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js